export default "__VITE_ASSET__8sbzqh0Y__"